import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { CreateFlashMessageAPI } from '../api/flashmessage/create/createflashmessagesapi';
import { CreateFlashMessageRequest } from '../api/flashmessage/create/createflashmessagesrequest';
import { CreateFlashMessageResponse } from '../api/flashmessage/create/createflashmessagesresponse';
import { DedicateFlashMessageAPI } from '../api/flashmessage/dedicate/dedicateflashmessagesapi';
import { DedicateFlashMessageRequest } from '../api/flashmessage/dedicate/dedicateflashmessagesrequest';
import { DedicateFlashMessageResponse } from '../api/flashmessage/dedicate/dedicateflashmessagesresponse';
import { DeleteFlashMessageAPI } from '../api/flashmessage/delete/deleteflashmessagesapi';
import { DeleteFlashMessageRequest } from '../api/flashmessage/delete/deleteflashmessagesrequest';
import { DeleteFlashMessageResponse } from '../api/flashmessage/delete/deleteflashmessagesresponse';
import { DeleteDedicateFlashMessageAPI } from '../api/flashmessage/deletededicate/deletededicateflashmessagesapi';
import { DeleteDedicateFlashMessageRequest } from '../api/flashmessage/deletededicate/deletededicateflashmessagesrequest';
import { DeleteDedicateFlashMessageResponse } from '../api/flashmessage/deletededicate/deletededicateflashmessagesresponse';
import { EditFlashMessageAPI } from '../api/flashmessage/edit/editflashmessagesapi';
import { EditFlashMessageRequest } from '../api/flashmessage/edit/editflashmessagesrequest';
import { EditFlashMessageResponse } from '../api/flashmessage/edit/editflashmessagesresponse';
import { GetDedicateFlashMessageAPI } from '../api/flashmessage/getdedicateflashmessages/getdedicateflashmessagesapi';
import { GetDedicateFlashMessageRequest } from '../api/flashmessage/getdedicateflashmessages/getdedicateflashmessagesrequest';
import { GetDedicateFlashMessageResponse } from '../api/flashmessage/getdedicateflashmessages/getdedicateflashmessagesresponse';
import { GetFlashMessageAPI } from '../api/flashmessage/getflashmessages/getflashmessagesapi';
import { GetFlashMessageRequest } from '../api/flashmessage/getflashmessages/getflashmessagesrequest';
import { GetFlashMessageResponse } from '../api/flashmessage/getflashmessages/getflashmessagesresponse';
import { GetFlashStatusAPI } from '../api/flashmessage/getflashstatus/getflashstatusapi';
import { GetFlashStatusRequest } from '../api/flashmessage/getflashstatus/getflashstatusrequest';
import { GetFlashStatusResponse } from '../api/flashmessage/getflashstatus/getflashstatusresponse';
import { FlashSubscriptionDetailsAPI } from '../api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsapi';
import { FlashSubscriptionDetailsRequest } from '../api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsrequest';
import { FlashSubscriptionDetailsResponse } from '../api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsresponse';
import { GetPredefinedFlashMessageAPI } from '../api/flashmessage/getpredefinedflashmessages/getpredefinedflashmessagesapi';
import { GetPredefinedFlashMessageRequest } from '../api/flashmessage/getpredefinedflashmessages/getpredefinedflashmessagesrequest';
import { GetPredefinedFlashMessageResponse } from '../api/flashmessage/getpredefinedflashmessages/getpredefinedflashmessagesresponse';
import { PlayPauseFlashMessageAPI } from '../api/flashmessage/playpause/playpauseflashmessagesapi';
import { PlayPauseFlashMessageRequest } from '../api/flashmessage/playpause/playpauseflashmessagesrequest';
import { PlayPauseFlashMessageResponse } from '../api/flashmessage/playpause/playpuaseflashmessagesresponse';
import { SetFlashMessageAPI } from '../api/flashmessage/setflashmessge/setflashmessageapi';
import { SetFlashMessageRequest } from '../api/flashmessage/setflashmessge/setflashmessagerequest';
import { SetFlashMessageResponse } from '../api/flashmessage/setflashmessge/setflashmessageresponse';
import { SubscribeUnSubscribeFlashMessageAPI } from '../api/flashmessage/subscribeunsubscribe/subscribeunsubscribeflashmessagesapi';
import { SubscribeUnSubscribeFlashMessageRequest } from '../api/flashmessage/subscribeunsubscribe/subscribeunsubscribeflashmessagesrequest';
import { SubscribeUnSubscribeFlashMessageResponse } from '../api/flashmessage/subscribeunsubscribe/subscribeunsubscribeflashmessagesresponse';
import { FlashMessageGenerateTokenAPI } from '../api/flashmessagegeneratetoken/flashmessagegeneratetokenapi';
import { FlashMessageGenerateTokenRequest } from '../api/flashmessagegeneratetoken/flashmessagegeneratetokenrequest';
import { FlashMessageGenerateTokenResponse } from '../api/flashmessagegeneratetoken/flashmessagegeneratetokenresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { CreateFlashMessageAPIProcessorImpl } from '../processor/createflashmessagesapiprocessor';
import { DedicateFlashMessageAPIProcessorImpl } from '../processor/dedicateflashmessageapiprocessor';
import { DeleteDedicateFlashMessageAPIProcessorImpl } from '../processor/deletededicateflashmessagesapiprocessor';
import { DeleteFlashMessageAPIProcessorImpl } from '../processor/deleteflashmessagesapiprocessor';
import { EditFlashMessageAPIProcessorImpl } from '../processor/editflashmessagesapiprocessor';
import { FlashMessageGenerateTokenAPIProcessorImpl } from '../processor/generateflashtokenapiprocessor';
import { GetDedicateFlashMessageAPIProcessorImpl } from '../processor/getdedicateflashmessagesapiprocessor';
import { GetFlashMessageAPIProcessorImpl } from '../processor/getflashmessagesapiprocessor';
import { GetFlashStatusAPIProcessorImpl } from '../processor/getflashstatusapiprocessor';
import { FlashSubscriptionDetailsAPIProcessorImpl } from '../processor/getflashsubscriptiondetailsapiprocessor';
import { GetPredefinedFlashMessageAPIProcessorImpl } from '../processor/getpredefinedflashmessagesapiprocessor';
import { PlayPauseFlashMessageAPIProcessorImpl } from '../processor/playpauseflashmessagesapiprocessor';
import { SetFlashMessageAPIProcessorImpl } from '../processor/setflashmessageapiprocessor';
import { SubscribeUnsubscribeFlashMessageAPIProcessorImpl } from '../processor/subscribeunsubscribeflashmessagesapiprocessor';

import { ProcessorFactoryImpl } from './processorfactory';

export class FlashMessageProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    getFlashMessageAPIProcessor():APIProcessor<GetFlashMessageRequest, GetFlashMessageResponse>
    {   
        return new GetFlashMessageAPIProcessorImpl(this.getContext(), new GetFlashMessageAPI(this.getHttpClient(), this.getContext()));
    }

    getFlashStatusAPIProcessor():APIProcessor<GetFlashStatusRequest, GetFlashStatusResponse>
    {   
        return new GetFlashStatusAPIProcessorImpl(this.getContext(), new GetFlashStatusAPI(this.getHttpClient(), this.getContext()));
    }

    getPredefinedFlashMessageAPIProcessor():APIProcessor<GetPredefinedFlashMessageRequest, GetPredefinedFlashMessageResponse>
    {   
        return new GetPredefinedFlashMessageAPIProcessorImpl(this.getContext(), new GetPredefinedFlashMessageAPI(this.getHttpClient(), this.getContext()));
    }

    setFlashMessageAPIProcessor():APIProcessor<SetFlashMessageRequest, SetFlashMessageResponse>
    {
        return new SetFlashMessageAPIProcessorImpl(this.getContext(), new SetFlashMessageAPI(this.getHttpClient(), this.getContext()));
    }

    createFlashMessageAPIProcessor():APIProcessor<CreateFlashMessageRequest, CreateFlashMessageResponse>
    {
        return new CreateFlashMessageAPIProcessorImpl(this.getContext(), new CreateFlashMessageAPI(this.getHttpClient(), this.getContext()));
    }

    editFlashMessageAPIProcessor():APIProcessor<EditFlashMessageRequest, EditFlashMessageResponse>
    {
        return new EditFlashMessageAPIProcessorImpl(this.getContext(), new EditFlashMessageAPI(this.getHttpClient(), this.getContext()));
    }

    deleteFlashMessageAPIProcessor():APIProcessor<DeleteFlashMessageRequest, DeleteFlashMessageResponse>
    {
        return new DeleteFlashMessageAPIProcessorImpl(this.getContext(), new DeleteFlashMessageAPI(this.getHttpClient(), this.getContext()));
    }

    playpauseFlashMessageAPIProcessor():APIProcessor<PlayPauseFlashMessageRequest, PlayPauseFlashMessageResponse>
    {
        return new PlayPauseFlashMessageAPIProcessorImpl(this.getContext(), new PlayPauseFlashMessageAPI(this.getHttpClient(), this.getContext()));
    }

    subscribeunsubscrbeFlashMessageAPIProcessor():APIProcessor<SubscribeUnSubscribeFlashMessageRequest, SubscribeUnSubscribeFlashMessageResponse>
    {
        return new SubscribeUnsubscribeFlashMessageAPIProcessorImpl(this.getContext(), new SubscribeUnSubscribeFlashMessageAPI(this.getHttpClient(), this.getContext()));
    }

    generateTokenProcessor():APIProcessor<FlashMessageGenerateTokenRequest, FlashMessageGenerateTokenResponse>
    {
        return new FlashMessageGenerateTokenAPIProcessorImpl(this.getContext(), new FlashMessageGenerateTokenAPI(this.getHttpClient(), this.getContext()));
    }

    getSubscriptionAPIProcessor():APIProcessor<FlashSubscriptionDetailsRequest, FlashSubscriptionDetailsResponse>
    {
        return new FlashSubscriptionDetailsAPIProcessorImpl(this.getContext(), new FlashSubscriptionDetailsAPI(this.getHttpClient(), this.getContext()));
    }

    getDedicateFlashAPIProcessor():APIProcessor<DedicateFlashMessageRequest, DedicateFlashMessageResponse>
    {
        return new DedicateFlashMessageAPIProcessorImpl(this.getContext(), new DedicateFlashMessageAPI(this.getHttpClient(), this.getContext()));
    }

    deleteDedicateFlashAPIProcessor():APIProcessor<DeleteDedicateFlashMessageRequest, DeleteDedicateFlashMessageResponse>
    {
        return new DeleteDedicateFlashMessageAPIProcessorImpl(this.getContext(), new DeleteDedicateFlashMessageAPI(this.getHttpClient(), this.getContext()));
    }

    getDedicateFlashDetailsAPIProcessor():APIProcessor<GetDedicateFlashMessageRequest, GetDedicateFlashMessageResponse>
    {
        return new GetDedicateFlashMessageAPIProcessorImpl(this.getContext(), new GetDedicateFlashMessageAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/flashmessageprocessorfactory.tsx